import { useContext } from 'react';
import { TeamsAuthContext } from '@/contexts/TeamsAuthContext';

/**
 * Hook to access Teams authentication context
 * @returns Teams auth context if available, null if not in Teams environment
 */
export const useTeamsAuth = () => {
  const context = useContext(TeamsAuthContext);
  // Return null instead of throwing when not in Teams environment
  // This allows the hook to be called unconditionally (React Rules of Hooks)
  return context ?? null;
};
